<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded">
<p class="ded"><a class="page" id="pv"></a>Dedicated to my parents,</p>
<p class="ded1">Chaplain (LTC) Herbert Lawrence Marbury and Annette Robinson Marbury, who taught me to remember the struggle and to join it.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Marbury-0005.vue?3d37e66c